import * as React from "react";

function useSessionStorage(key: string, initialValue: string) {
  const [storedValue, setStoredValue] = React.useState<string>(() => {
    try {
      const item = sessionStorage.getItem(key);
      return item ? item : initialValue;
    } catch (error) {
      console.error(error);
      return initialValue;
    }
  });

  const setValue = (value: string) => {
    try {
      const updatedValue = storedValue ? `${storedValue},${value}` : value;
      setStoredValue(updatedValue);
      sessionStorage.setItem(key, updatedValue);
    } catch (error) {
      console.error(error);
    }
  };

  return [storedValue, setValue] as const;
}

export default useSessionStorage;
